<div class="dashboard-kapsayici">
  <div class="uygulama-grid">
    @for (kart of kartlar; track kart.route) {
      @if (kartGorunurMu(kart)) {
        <a class="uygulama-kart" [routerLink]="[kart.route]" [style.--kart-renk]="kart.renk">
          <div class="uygulama-kart-ust" [style.background]="kart.gradient">
            <span class="uygulama-kart-simge">{{ kart.ikon }}</span>
          </div>
          <div class="uygulama-kart-alt">
            <div class="uygulama-kart-baslik">{{ kart.baslik }}</div>
            <div class="uygulama-kart-aciklama">{{ kart.aciklama }}</div>
          </div>
        </a>
      }
    }
  </div>

  <div class="dashboard-pdks-satir">
    <pdks-aktif-kart class="dashboard-pdks"></pdks-aktif-kart>
  </div>

  @if (false && tumWidgetler().length) {
    <div class="widget-bolumu">
      <div class="widget-baslik-cubugu">
        @if (duzenleModu()) {
          <button nz-button nzSize="small" (click)="yeniSablonEkle()">+ Ekle</button>
          <button nz-button nzSize="small" nzDanger (click)="layoutSifirla()">Sıfırla</button>
          <button nz-button nzType="primary" nzSize="small" (click)="kaydet()">Kaydet</button>
        }
        <button nz-button nzType="text" nzSize="small" class="duzenleme-btn"
                (click)="duzenleModu.set(!duzenleModu())">
          {{ duzenleModu() ? 'Bitir' : 'Düzenle' }}
        </button>
      </div>
      <div class="dashboard-grid" [class.duzenleme-aktif]="duzenleModu()"
           cdkDropList [cdkDropListDisabled]="!duzenleModu()" (cdkDropListDropped)="onDrop($event)">
        @for (s of tumWidgetler(); track s.id) {
          <div class="widget-hucre" cdkDrag [cdkDragDisabled]="!duzenleModu()"
               [style.grid-column]="'span ' + s.pozisyon?.genislik"
               [style.grid-row]="'span ' + s.pozisyon?.yukseklik">
            <sablon-renderer [sablon]="s" [olaylarAktif]="true"
                             [duzenlenebilir]="duzenleModu()" />
            @if (duzenleModu()) {
              <div class="widget-hucre-islemler">
                <button class="widget-btn" (click)="sablonDuzenle(s)">&#9881;&#65039;</button>
                <button class="widget-btn widget-btn-sil" (click)="sablonSil(s.id!)">&times;</button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
